var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseIcon = function SvgCollapseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 2 1.09 6.26L22 9l-7.26 5.74L16.5 22 12 18.5 7.5 22l1.76-7.26L2 9l8.91-.74zm0 3.8-.5 3.9-3.9.3 3.3 3.3-.7 3.9 1.8-1.1 1.8 1.1-.7-3.9 3.3-3.3-3.9-.3z"
  })));
};
export default SvgCollapseIcon;